import React from "react";

export function AdminTable({ columns = [], rows = [], emptyLabel = "Aucun résultat", testId }) {
    return (
        <div
            data-testid={testId || "admin-table"}
            className="md-scroll overflow-x-auto rounded-xl border border-md-border bg-md-surface"
        >
            <table className="min-w-full divide-y divide-md-border text-sm">
                <thead className="bg-md-surface-2">
                    <tr>
                        {columns.map((c) => (
                            <th
                                key={c.key}
                                className={`px-4 py-3 text-left text-xs font-bold uppercase tracking-wider text-md-text-2 ${c.headerClassName || ""}`}
                            >
                                {c.label}
                            </th>
                        ))}
                    </tr>
                </thead>
                <tbody className="divide-y divide-md-border">
                    {rows.length === 0 ? (
                        <tr>
                            <td colSpan={columns.length} className="px-4 py-10 text-center text-sm text-md-text-2">
                                {emptyLabel}
                            </td>
                        </tr>
                    ) : (
                        rows.map((row, idx) => (
                            <tr key={row.id || idx} className="hover:bg-md-surface-2/60">
                                {columns.map((c) => (
                                    <td
                                        key={c.key}
                                        className={`px-4 py-3 align-middle text-md-text ${c.className || ""}`}
                                    >
                                        {c.render ? c.render(row) : row[c.key]}
                                    </td>
                                ))}
                            </tr>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default AdminTable;
